import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FaRegCircleXmark } from "react-icons/fa6";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { deleteAd, getAllAds } from "../../store/slices/apiAdsSlice";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DeleteModalAds = ({ id }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleDeleteItem = async () => {
    await dispatch(deleteAd(id));
    toast.success("Ads u fshi me sukses!");
    dispatch(getAllAds());
    handleCloseModal();
  };

  return (
    <div>
      <button
        data-modal-target="popup-modal"
        data-modal-toggle="popup-modal"
        className="text-danger mx-1"
        onClick={handleOpenModal}
      >
        <FaRegCircleXmark className="w-5 h-5" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 sm:px-6">
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>

          <div className="relative w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-xl z-10">
            <button
              type="button"
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 dark:hover:text-white rounded-full w-8 h-8 flex justify-center items-center"
              onClick={handleCloseModal}
            >
              <FaRegCircleXmark className="w-5 h-5" />
            </button>

            <div className="p-6 text-center">
              <div className="mx-auto text-gray-400 w-12 h-12 dark:text-gray-200 mb-6">
                <AiOutlineExclamationCircle className="w-16 h-16 mx-auto" />
              </div>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                A jeni të sigurt që dëshironi ta fshini?
              </h3>
              <div className="flex flex-col sm:flex-row justify-center gap-3">
                <button
                  data-modal-hide="popup-modal"
                  type="button"
                  onClick={handleDeleteItem}
                  className="w-full sm:w-auto text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm px-5 py-2.5"
                >
                  Po, vazhdo
                </button>
                <button
                  data-modal-hide="popup-modal"
                  type="button"
                  onClick={handleCloseModal}
                  className="w-full sm:w-auto text-gray-700 bg-white hover:bg-gray-100 border border-gray-300 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-gray-600 dark:text-gray-300 dark:border-gray-500 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  Jo, anulo
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default DeleteModalAds;
